import { combineReducers } from "redux";
import appSlice from "./appSlice";

const rootSlice = combineReducers({
    app: appSlice,
});

export default rootSlice;
